// EditTestDialog.js
import React, { useState } from 'react';
import { Dialog, DialogActions, DialogContent, DialogTitle, Button, TextField, CircularProgress } from '@mui/material';
import dayjs from 'dayjs';
import { updateDoc, doc } from 'firebase/firestore';
import {db} from '../Configuration';
import { isUrduText } from '../utils/urduFont';

const EditTestDialog = ({ open, onClose, test }) => {
  const [testName, setTestName] = useState(test.testName);
  const [date, setDate] = useState(dayjs(test.date, 'YYYY-MM-DD'));
  const [submitting, setSubmitting] = useState(false);

  const handleSave = async () => {
    setSubmitting(true);
    try {
      const testDocRef = doc(db, 'Tests', test.id);

      // Format date to 'YYYY-MM-DD' before saving
      const formattedDate = date.format('YYYY-MM-DD');

      await updateDoc(testDocRef, {
        testName,
        date: formattedDate,  // Save as a formatted string in 'YYYY-MM-DD'
      });
      onClose();
    } catch (error) {
      console.error('Error updating test:', error);
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <Dialog open={open} onClose={onClose}>
      <DialogTitle>Edit Test</DialogTitle>
      <DialogContent>
        <TextField
          margin="dense"
          label="Test Name"
          type="text"
          fullWidth
          value={testName}
          onChange={(e) => setTestName(e.target.value)}
          sx={{
            '& .MuiInputBase-input': {
              fontFamily: isUrduText(testName)
                ? "'Noto Nastaliq Urdu', 'Jameel Noori Nastaleeq', serif"
                : 'inherit',
              direction: 'ltr',
              textAlign: 'left'
            }
          }}
        />
        <TextField
          margin="dense"
          label="Test Date"
          type="date"
          fullWidth
          value={date.format('YYYY-MM-DD')}
          onChange={(e) => setDate(dayjs(e.target.value))}
          InputLabelProps={{
            shrink: true,
          }}
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} color="primary" disabled={submitting}>
          Cancel
        </Button>
        <Button 
          onClick={handleSave} 
          color="primary" 
          disabled={submitting}
          startIcon={submitting ? <CircularProgress size={20} /> : null}
        >
          {submitting ? 'Saving...' : 'Save'}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default EditTestDialog;
